import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full'
  },
  {
    path: 'inicio',
    loadChildren: () => import('./pages/inicio/inicio.module').then( m => m.InicioPageModule)
  },
 
  {
    path: 'configuracion',
    loadChildren: () => import('./pages/configuracion/configuracion.module').then( m => m.ConfiguracionPageModule)
  },
 
  
  {
    path: 'derechos',
    loadChildren: () => import('./pages/derechos/derechos.module').then( m => m.DerechosPageModule)
  },
  
  {
    path: 'calendario',
    loadChildren: () => import('./pages/calendario/calendario.module').then( m => m.CalendarioPageModule)
  },
  {
    path: 'imprimir',
    loadChildren: () => import('./pages/imprimir/imprimir.module').then( m => m.ImprimirPageModule)
  },
  
  {
    path: 'barcode',
    loadChildren: () => import('./pages/barcode/barcode.module').then( m => m.BarcodePageModule)
  },
 
  
 
  {
    path: 'dasboard',
    loadChildren: () => import('./pages/dasboard/dasboard.module').then( m => m.DasboardPageModule)
  },
  
 
  {
    path: 'verdocumentos',
    loadChildren: () => import('./pages/verdocumentos/verdocumentos.module').then( m => m.VerdocumentosPageModule)
  },
  {
    path: 'cargardoc',
    loadChildren: () => import('./pages/cargardoc/cargardoc.module').then( m => m.CargardocPageModule)
  },
 
 
  {
    path: 'inventario',
    loadChildren: () => import('./pages/inventario/inventario.module').then( m => m.InventarioPageModule)
  }, 
 
  {
    path: 'estructura',
    loadChildren: () => import('./pages/estructura/estructura.module').then( m => m.EstructuraPageModule)
  },   {
    path: 'ordenes',
    loadChildren: () => import('./pages/ordenes/ordenes.module').then( m => m.OrdenesPageModule)
  },
  {
    path: 'vehiculos',
    loadChildren: () => import('./pages/vehiculos/vehiculos.module').then( m => m.VehiculosPageModule)
  },
  {
    path: 'conductores',
    loadChildren: () => import('./pages/conductores/conductores.module').then( m => m.ConductoresPageModule)
  },
  {
    path: 'propietarios',
    loadChildren: () => import('./pages/propietarios/propietarios.module').then( m => m.PropietariosPageModule)
  },
  {
    path: 'contratistas',
    loadChildren: () => import('./pages/contratistas/contratistas.module').then( m => m.ContratistasPageModule)
  },
  {
    path: 'viajes',
    loadChildren: () => import('./pages/viajes/viajes.module').then( m => m.ViajesPageModule)
  },
  {
    path: 'simulador',
    loadChildren: () => import('./pages/simulador/simulador.module').then( m => m.SimuladorPageModule)
  },
  
  {
    path: 'mantenimiento',
    loadChildren: () => import('./pages/mantenimiento/mantenimiento.module').then( m => m.MantenimientoPageModule)
  },
  {
    path: 'legalizacion',
    loadChildren: () => import('./pages/legalizacion/legalizacion.module').then( m => m.LegalizacionPageModule)
  },
  {
    path: 'precios',
    loadChildren: () => import('./pages/precios/precios.module').then( m => m.PreciosPageModule)
  },
  {
    path: 'anticipos',
    loadChildren: () => import('./pages/anticipos/anticipos.module').then( m => m.AnticiposPageModule)
  },
  {
    path: 'novedades',
    loadChildren: () => import('./pages/novedades/novedades.module').then( m => m.NovedadesPageModule)
  },
  {
    path: 'abonos',
    loadChildren: () => import('./pages/abonos/abonos.module').then( m => m.AbonosPageModule)
  },
  {
    path: 'pagos',
    loadChildren: () => import('./pages/pagos/pagos.module').then( m => m.PagosPageModule)
  },
  {
    path: 'finanzas',
    loadChildren: () => import('./pages/finanzas/finanzas.module').then( m => m.FinanzasPageModule)
  },
  {
    path: 'cartera',
    loadChildren: () => import('./pages/cartera/cartera.module').then( m => m.CarteraPageModule)
  },
  {
    path: 'egresos',
    loadChildren: () => import('./pages/egresos/egresos.module').then( m => m.EgresosPageModule)
  },
  {
    path: 'inmuebles',
    loadChildren: () => import('./pages/inmuebles/inmuebles.module').then( m => m.InmueblesPageModule)
  },
  {
    path: 'carpeta',
    loadChildren: () => import('./pages/carpeta/carpeta.module').then( m => m.CarpetaPageModule)
  },
  {
    path: 'documentos',
    loadChildren: () => import('./pages/documentos/documentos.module').then( m => m.DocumentosPageModule)
  },
 
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
